import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { TimeOfLossContainer } from '~/components/ClaimPage';
import { usePolicy } from '~/components/PolicyContainer';

import GenericClaimBarField from './GenericClaimBarField';

type TimeOfLossProps = {
  displayName?: string;
};

const TimeOfLoss = ({ displayName = 'Time of Loss' }: TimeOfLossProps) => {
  const { claim, onAsyncClaimUpdate } = useClaim({ claimRequired: true });
  const { policy } = usePolicy();

  return !policy?.is_claims_made ? (
    <GenericClaimBarField title={displayName} allowWrapping={false}>
      {/*hack *: is child, this targets child of child*/}
      <div className="*:*:text-nowrap">
        <TimeOfLossContainer claim={claim} onClaimUpdate={onAsyncClaimUpdate} />
      </div>
    </GenericClaimBarField>
  ) : null;
};

export default TimeOfLoss;
